// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-components-auth').PrivacyPolicy

      resolve(View)

    /* Webpack named bundle   */
    }, 'privacypolicy')
  })
}

export default asyncRoute({getComponent, reducers: []})
